import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserAppFeatureModel} from './user-app-feature-model';
import {FeatureModel} from '../../api/feature-model';
import {FeaturesService} from '../../api/features.service';

@Component({
  selector: 'app-user-app-features',
  templateUrl: './user-app-features.component.html',
  styleUrls: ['./user-app-features.component.scss']
})
export class UserAppFeaturesComponent implements OnInit {

  @Input()
  get features(): string {
    return this._features;
  }

  set features(value: string) {
    this._features = value;
    this.featuresChange.emit(this._features);
    this.fillFeatureList();
    console.log(value);
  }

  constructor(private featureService: FeaturesService) { }

  featureList: UserAppFeatureModel[] = [];
  allFeatures: FeatureModel[] = [];
  // tslint:disable-next-line:variable-name
  private _features: string;

  @Output() featuresChange: EventEmitter<string> = new EventEmitter<string>();

  // tslint:disable-next-line:variable-name
  private __allowedChangeInProcess__ = false;

  async ngOnInit() {
    this.featureList = [];
    this.allFeatures = await this.featureService.get().toPromise();
    this.fillFeatureList();
  }

  private buildFeaturesString(): string {
    const result = this.featureList
      .filter(x => x.allowed)
      .map(x => x.feature.code)
      .join(', ');
    return `[${result}]`;
  }

  private fillFeatureList() {
    // tslint:disable-next-line:no-debugger
    // debugger;
    if (this.allFeatures.length === 0) { return; }

    this.featureList = this.allFeatures.map(f => {
      const vm = new UserAppFeatureModel();
      vm.feature = f;

      if (this._features != null) {
        if (this._features.includes(f.code)) {
          vm.allowed = true;
        }
      }

      vm.allowedOnChange = () => this.onAllowedChanged(vm);

      return vm;
    });
  }

  private onAllowedChanged(vm: UserAppFeatureModel) {
    if (this.__allowedChangeInProcess__) { return; }

    this.__allowedChangeInProcess__ = true;

    if (vm.allowed && vm.feature.group != null) {
      const otherGroupItems = this.featureList
        .filter(fvm => fvm.allowed)
        .filter(fvm => fvm.feature.group === vm.feature.group)
        .filter(fvm => fvm.feature.code !== vm.feature.code);

      for (const fvm of otherGroupItems) {
        fvm.allowed = false;
      }
    }

    this.features = this.buildFeaturesString();
    this.__allowedChangeInProcess__ = false;
  }
}
